import React from 'react';

import {defaultTheme} from '@stencil/build-theme';

import ActivitiesIcon from '../../stories/Icons/Amenities/ActivitiesIcon';
import AirportTransportIcon from '../../stories/Icons/Amenities/AirportTransportIcon';
import BanquetHallIcon from '../../stories/Icons/Amenities/BanquetHallIcon';
import Bathroom from '../../stories/Icons/Amenities/BathroomIcon';
import BellboyService from '../../stories/Icons/Amenities/BellboyServiceIcon';
import CctvIcon from '../../stories/Icons/Amenities/CctvIcon';
import CleanRoomIcon from '../../stories/Icons/Amenities/CleanRoomIcon';
import ConferenceRoomIcon from '../../stories/Icons/Amenities/ConferenceRoomIcon';
import DailyHousekeeping from '../../stories/Icons/Amenities/DailyHousekeepingIcon';
import DailyNewspaper from '../../stories/Icons/Amenities/DailyNewspapeIcon';
import DoctorOnCall from '../../stories/Icons/Amenities/DoctorOnCallIcon';
import ElectricSmokeDetector from '../../stories/Icons/Amenities/ElectricSmokeDetectorIcon';
import Elevator from '../../stories/Icons/Amenities/ElevatorIcon';
import FreeParking from '../../stories/Icons/Amenities/FreeParkingIcon';
import HouseKeepingIcon from '../../stories/Icons/Amenities/HouseKeepingIcon';
import InternationalPlug from '../../stories/Icons/Amenities/InternationalPlugIcon';
import IronAndIroningBoard from '../../stories/Icons/Amenities/IronAndIroningBoard';
import MiniRefrigirator from '../../stories/Icons/Amenities/MiniRefrigiratorIcon';
import MoneyExchange from '../../stories/Icons/Amenities/MoneyExchangeIcon';
import ParkingIcon from '../../stories/Icons/Amenities/ParkingIcon';
import Photocopy from '../../stories/Icons/Amenities/PhotocopyIcon';
import PowerBackupIcon from '../../stories/Icons/Amenities/PowerBackupIcon';
import RestaurantIcon from '../../stories/Icons/Amenities/RestaurantIcon';
import RoomServiceIcon from '../../stories/Icons/Amenities/RoomServiceIcon';
import Safe from '../../stories/Icons/Amenities/SafeIcon';
import Security from '../../stories/Icons/Amenities/SecurityIcon';
import SpaIcon from '../../stories/Icons/Amenities/SpaIcon';
import SpeciallyAbledAssistance from '../../stories/Icons/Amenities/SpeciallyAbledAssistanceIcon';
import SwimmingIcon from '../../stories/Icons/Amenities/SwimmingIcon';
import Telephone from '../../stories/Icons/Amenities/TelephoneIcon';
import TvWithCable from '../../stories/Icons/Amenities/TvWithCableIcon';
import Umbrella from '../../stories/Icons/Amenities/UmbrellaIcon';
import WheelchairsAvailable from '../../stories/Icons/Amenities/WheelchairsAvailableIcon';
import WifiIcon from '../../stories/Icons/Amenities/WifiIcon';
import LaundryIcon from '../../stories/Icons/LaundryIcon';
import RoundedCheckbox from '../../stories/Icons/RoundedCheckbox';

import HappyWifiIcon from '@stencil/icons/src/HappyWifiIcon/HappyWifiIcon';
import HappyBedIcon from '@stencil/icons/src/HappyBedIcon/HappyBedIcon';

const AmenitiesIconSelector = ({
  name = '',
  styleProps,
}: {
  name: string;
  styleProps?: {
    [k: string]: string; // better typescript – 🐨 css properties
  };
}) => {
  if (!name) return <RoundedCheckbox {...styleProps} />;

  switch (name) {
    case 'Umbrella':
      return <Umbrella {...styleProps} />;
    case 'International Plug':
      return <InternationalPlug {...styleProps} />;
    case 'Mini Refrigerator':
      return <MiniRefrigirator {...styleProps} />;
    case 'Security':
      return <Security {...styleProps} />;
    case 'Free parking area':
      return <FreeParking {...styleProps} />;
    case 'Telephone':
      return <Telephone {...styleProps} />;
    case 'Doctor on Call':
      return <DoctorOnCall {...styleProps} />;
    case 'Money Exchange Facility':
      return <MoneyExchange {...styleProps} />;
    case 'Elevator/Lift':
      return <Elevator {...styleProps} />;
    case 'Daily housekeeping':
      return <DailyHousekeeping {...styleProps} />;
    case 'Bathroom':
      return <Bathroom {...styleProps} />;
    case 'Private safe box':
      return <Safe {...styleProps} />;
    case 'Electronic smoke detector':
      return <ElectricSmokeDetector {...styleProps} />;
    case 'Photocopying':
      return <Photocopy {...styleProps} />;
    case 'Daily newspaper':
      return <DailyNewspaper {...styleProps} />;
    case 'Iron and ironing board':
      return <IronAndIroningBoard {...styleProps} />;
    case 'Bellboy service':
      return <BellboyService {...styleProps} />;
    case 'Wheelchairs available':
      return <WheelchairsAvailable {...styleProps} />;
    case 'TV with Cable channels':
      return <TvWithCable {...styleProps} />;
    case 'Specially-abled assistance':
      return <SpeciallyAbledAssistance {...styleProps} />;
    case 'Room Service':
      return <RoomServiceIcon {...styleProps} />;
    case 'Dining Area':
      return <RestaurantIcon {...styleProps} />;
    case 'Restaurant':
      return <RestaurantIcon {...styleProps} />;
    case 'Restaurant/Coffee Shop':
      return <RestaurantIcon {...styleProps} />;
    case 'Kitchen':
      return <RestaurantIcon {...styleProps} />;
    case 'Parking Facility':
      return <ParkingIcon {...styleProps} />;
    case 'Free parking area':
      return <ParkingIcon {...styleProps} />;

    case 'Free Wifi':
      return <HappyWifiIcon {...styleProps} />;
    case 'Free Internet':
      return <HappyWifiIcon {...styleProps} />;
    // case 'Safe':
    //   return <PowerBackupIcon {...styleProps} />;
    case 'Laundry service':
      return <HouseKeepingIcon {...styleProps} />;
    case 'Laundry Service':
      return <HouseKeepingIcon {...styleProps} />;

    case 'Banquet hall':
      return <BanquetHallIcon {...styleProps} />;
    case 'Banquet Hall':
      return <BanquetHallIcon {...styleProps} />;

    case 'CCTV':
      return <CctvIcon {...styleProps} />;
    case 'CCTV surveillance':
      return <CctvIcon {...styleProps} />;
    case 'Clean Room':
      return <CleanRoomIcon {...styleProps} />;

    case 'Power backup':
      return <PowerBackupIcon {...styleProps} />;
    case 'Conference Room':
      return <ConferenceRoomIcon {...styleProps} />;

    case 'Room Service':
      return <RoomServiceIcon {...styleProps} />;
    case 'Daily housekeeping':
      return <HouseKeepingIcon {...styleProps} />;
    case 'Caretaker':
      return <HouseKeepingIcon {...styleProps} />;

    case 'CCTV surveillance':
      return <CctvIcon {...styleProps} />;
    case 'CCTV':
      return <CctvIcon {...styleProps} />;

    case 'Dining':
      return <RestaurantIcon {...styleProps} />;
    case 'Restaurant/Coffee Shop':
      return <RestaurantIcon {...styleProps} />;
    case 'Dining Area':
      return <RestaurantIcon {...styleProps} />;
    case 'Restaurant':
      return <RestaurantIcon {...styleProps} />;

    case 'Laundry Service':
      return <LaundryIcon {...styleProps} />;
    case 'Laundry Service (At a charge)':
      return <LaundryIcon {...styleProps} />;
    case 'Spa':
      return <SpaIcon {...styleProps} />;
    case 'Outdoor Activities':
      return <ActivitiesIcon {...styleProps} />;
    case 'Parking Facility':
      return <ParkingIcon {...styleProps} />;
    case 'Swimming':
      return <SwimmingIcon {...styleProps} />;
    case 'Swimming Pool':
      return <SwimmingIcon {...styleProps} />;

    case 'Travel Assistance':
      return <AirportTransportIcon {...styleProps} />;
    case 'airport Transfer (Surcharge)':
      return <AirportTransportIcon {...styleProps} />;

    default:
      return <RoundedCheckbox {...styleProps} />;
  }
};

export default AmenitiesIconSelector;
